import React from 'react'

import { MovieCard, BlurBack } from './style'

type VideoCardProps = {
  bgImg: string
  videoUrl: string
}

export const VideoCard = ({ bgImg, videoUrl }: VideoCardProps) => {
  return (
    <MovieCard onClick={() => window.open(videoUrl, '_blank')}>
      <BlurBack bgImg={bgImg} />
    </MovieCard>
  )
}
